import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Header, Footer } from 'components';
import { useMyContext } from 'hooks';
import { Wrapper, StyledHeader, Content } from './styles'

const GraphicTemplate = ({ header, secondHeader, thirdHeader, footer, children }) => {
  const { toggleTheme, setThemeType } = useMyContext();
  const { innerWidth } = window;

  useEffect(() => {
    if(innerWidth <= 920){
      setThemeType('dark');
    }
  }, []);

  return (
    <Wrapper id="graphic-teamplate">
      <Header>
        {header}
      </Header>
      <StyledHeader bgColor="white">
        {secondHeader}
      </StyledHeader>
      <StyledHeader bgColor="white" style={{border: '14px 10px', margin: innerWidth <= 920 ? 0 : '16px 0px'}}>
        { thirdHeader }
      </StyledHeader>
      <Content>
        {children}
      </Content>
      {footer && (
        <Footer>
          {footer}
        </Footer>
      )}
    </Wrapper>
  )
}

GraphicTemplate.propTypes = {
  header: PropTypes.node.isRequired,
  secondHeader: PropTypes.node,
}

export default GraphicTemplate;